import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-status-card',
  imports: [CommonModule, MatIconModule],
  templateUrl: './status-card.html',
  styleUrl: './status-card.scss'
})
export class StatusCard {
  @Input() texto: string = 'Status';
  @Input() cor: string = '#ccc'; // ex: '#e74c3c'
  @Input() icone: string = 'schedule'; // ícone Material, como 'schedule', 'check', etc.
  @Input() descricao: string = ''; // Subtítulo
  @Input() backgroundColor: string = 'white'; // Cor de fundo do card
}
